module.exports = __webpack_public_path__ + "img/h4.e8cd92c8.png";